// removed by extract-text-webpack-plugin
module.exports = {"container":"_2EomxO8fAH-nu0mcfXgfYW","button":"_2qo_ro6Pn5Pj6G1PUONkKK","input":"_2j_kvLIVAa9i1l-q9_sJCL","forgot":"_3gl2LH4IKFI6rlIVWhwLQs","error":"_1V9Y1_RFIhESsYitC8XGB1"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/container/LoginPage/index.css
// module id = 313
// module chunks = 0